// extracted by mini-css-extract-plugin
module.exports = {"container":"a9150b94","truncate":"_2989fa73","copyButton":"fbd04dd1"};